import React from 'react';
import { BrowserRouter, Navigate, Route, Routes, useParams } from 'react-router-dom';
import { BrandingProvider } from '../../contexts/BrandingContext';
import StorefrontRoot from './StorefrontRoot';
import StorefrontHome from './StorefrontHome';
import StorefrontCatalog from './StorefrontCatalog';
import StorefrontProduct from './StorefrontProduct';
import StorefrontCart from './StorefrontCart';
import StorefrontCheckout from './StorefrontCheckout';
import StorefrontOrder from './StorefrontOrder';
import LegacyLandingPageRedirect from './LegacyLandingPageRedirect';

const LowerCaseSlug: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { slug = '' } = useParams<{ slug: string }>();
    return slug !== slug.toLowerCase() ? <Navigate to={`/store/${slug.toLowerCase()}`} replace /> : <>{children}</>;
};

/**
 * Öffentliche Routen ohne Login (`/store/:slug/*`, alte `/p/:slug`-Links), eingehängt in `App.tsx`
 * vor der Admin-Shell. `BrandingProvider` liefert das Mandanten-Branding der Domain.
 */
const StorefrontApp: React.FC = () => (
    <BrandingProvider>
        <BrowserRouter>
            <Routes>
                <Route path="/store/:slug" element={<LowerCaseSlug><StorefrontRoot /></LowerCaseSlug>}>
                    <Route index element={<StorefrontHome />} />
                    <Route path="catalog" element={<StorefrontCatalog />} />
                    <Route path="products/:id" element={<StorefrontProduct />} />
                    <Route path="cart" element={<StorefrontCart />} />
                    <Route path="checkout" element={<StorefrontCheckout />} />
                    <Route path="orders/:uuid" element={<StorefrontOrder />} />
                </Route>
                <Route path="/p/:slug" element={<LegacyLandingPageRedirect />} />
                <Route path="/p/:slug/checkout" element={<LegacyLandingPageRedirect />} />
            </Routes>
        </BrowserRouter>
    </BrandingProvider>
);

export default StorefrontApp;
